import { BatchTypeState } from "@/vuex/modules/inventory/batchType/batchType.types";

export const state: BatchTypeState = {
  batchTypes: [],
  loading: false,
  pagination: null,
  batchType: null
};
